{
  "nm": "Main Scene",
  "ddd": 0,
  "h": 500,
  "w": 500,
  "meta": { "g": "@lottiefiles/creator 1.37.1" },
  "layers": [
    {
      "ty": 4,
      "nm": "Shape Layer - SVG 1",
      "sr": 1,
      "st": 0,
      "op": 66,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [45.37774991989136, 45.29157543182373] },
        "s": { "a": 0, "k": [524.0835, 524.0835] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251.9797, 251.5281] },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.55, "y": 0.06 },
              "i": { "x": 0.36, "y": 1 },
              "s": [0],
              "t": 33
            },
            { "s": [-360], "t": 63 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 1",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 1",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [6.313000000000002, 2.8108000000000004],
                    [6.759499999999996, -1.4367999999999999],
                    [4.623899999999999, -5.1355],
                    [0.7223000000000006, -6.8725999999999985],
                    [0, 0],
                    [-1.8496000000000024, 2.0542000000000016],
                    [-2.703800000000001, 0.5747],
                    [-2.525199999999998, -1.124299999999998],
                    [-1.3821000000000012, -2.393900000000002],
                    [0, 0]
                  ],
                  "o": [
                    [-3.455200000000005, -5.9846],
                    [-6.312999999999995, -2.8107000000000006],
                    [-6.759400000000003, 1.4367],
                    [-4.624000000000002, 5.135399999999997],
                    [0, 0],
                    [0.2890000000000015, -2.7489999999999952],
                    [1.8495999999999952, -2.0541999999999945],
                    [2.7036999999999978, -0.5747],
                    [2.525200000000005, 1.124299999999998],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [73.6384, 28.9378],
                    [58.6091, 15.4053],
                    [38.4958, 13.2914],
                    [20.9814, 23.4034],
                    [12.7555, 41.8789],
                    [32.2818, 43.9312],
                    [35.5722, 36.541],
                    [42.578, 32.4962],
                    [50.6232, 33.3418],
                    [56.635, 38.7548],
                    [73.6384, 28.9378]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "c": { "a": 0, "k": [0.702, 0.8196, 0.8392] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [43.1969485282898, 28.257174491882324] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [43.1969485282898, 28.257174491882324] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Shape Layer - SVG",
      "sr": 1,
      "st": 0,
      "op": 66,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [45.37774991989136, 45.29157543182373] },
        "s": { "a": 0, "k": [524.0835, 524.0835] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [251.9797, 251.5281] },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.55, "y": 0.06 },
              "i": { "x": 0.36, "y": 1 },
              "s": [0],
              "t": 0
            },
            { "s": [360], "t": 29 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "Group 2",
          "it": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "Path 2",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [-1.6333000000000002, -3.943099999999994],
                    [-3.0178999999999974, -3.0178999999999974],
                    [-3.943100000000001, -1.6333000000000055],
                    [-4.268000000000001, 0],
                    [-3.943099999999994, 1.6333000000000055],
                    [-3.0178999999999974, 3.0179000000000116],
                    [-1.6333000000000055, 3.943100000000001],
                    [0, 4.268000000000001],
                    [0, 0],
                    [0.6533000000000015, -1.5771999999999977],
                    [1.207100000000004, -1.2072000000000003],
                    [1.5772000000000048, -0.6532999999999944],
                    [1.7072000000000003, 0],
                    [1.5771999999999977, 0.6533000000000015],
                    [1.2072000000000003, 1.207100000000004],
                    [0.6532999999999944, 1.5772000000000048],
                    [0, 1.7072000000000003],
                    [0, 0]
                  ],
                  "o": [
                    [0, 4.268000000000001],
                    [1.6332999999999984, 3.943100000000001],
                    [3.017900000000001, 3.0179000000000116],
                    [3.943099999999994, 1.6333000000000055],
                    [4.268000000000001, 0],
                    [3.943100000000001, -1.6333000000000055],
                    [3.0179000000000116, -3.0178999999999974],
                    [1.6333000000000055, -3.943099999999994],
                    [0, 0],
                    [0, 1.7072000000000003],
                    [-0.6532999999999944, 1.5772000000000048],
                    [-1.2072000000000003, 1.207100000000004],
                    [-1.5771999999999977, 0.6533000000000015],
                    [-1.7072000000000003, 0],
                    [-1.5772000000000048, -0.6532999999999944],
                    [-1.2072000000000003, -1.2072000000000003],
                    [-0.6533000000000015, -1.5771999999999977],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [13, 45.5],
                    [15.4739, 57.9372],
                    [22.519, 68.481],
                    [33.0628, 75.5261],
                    [45.5, 78],
                    [57.9372, 75.5261],
                    [68.481, 68.481],
                    [75.5261, 57.9372],
                    [78, 45.5],
                    [58.5, 45.5],
                    [57.5104, 50.4749],
                    [54.6924, 54.6924],
                    [50.4749, 57.5104],
                    [45.5, 58.5],
                    [40.5251, 57.5104],
                    [36.3076, 54.6924],
                    [33.4896, 50.4749],
                    [32.5, 45.5],
                    [13, 45.5]
                  ]
                }
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "Fill",
              "c": { "a": 0, "k": [0.0196, 0.3137, 0.3608] },
              "r": 1,
              "o": { "a": 0, "k": 100 }
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [45.500000000000014, 61.750000000000014] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [45.500000000000014, 61.750000000000014] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 2
    }
  ],
  "v": "5.7.0",
  "fr": 30,
  "op": 66,
  "ip": 0,
  "assets": []
}
